const sv = {
  "about_us": "Om oss",
  "activities": "Aktiviteter",
  "adult": "Vuxen",
  "adults": "Vuxna",
  "age": "Ålder",
  "all": "Alla",
  "app_name": "Gausta",
  "appInfo": "Ladda hem Gausta-appen – din guide till Gausta",
  "articles": "Artiklar",
  "bottom_collection_about": 'Om Gausta',
  "bottom_collection_cabins": 'Stugor till salu',
  "bottom_collection_customer": 'Kundservice',
  "bottom_collection_news": 'Nyheter',
  "bottom_collection_work": 'Jobba på Gausta',
  "title_service": 'Kundservice',
  "breadcrumb_prefix": "Du är här:",
  "cabins_and_apartments": "Stugor och lägenheter",
  "call": "Telefon",
  "career_application_period": "Ansökningsperiod",
  "career_application": "Ansökan",
  "career_available_positions": "Lediga tjänster",
  "career_employer": "Arbetsgivare",
  "career_jobtitle": "Jobbtitel",
  "career_jobtype": "Jobbtyp",
  "center_collection1_accomodation": 'Boende',
  "center_collection1_here": 'Resa hit',
  "center_collection1_maps": 'Kartor',
  "center_collection1_offers": 'Erbjudanden och kampanjer',
  "center_collection1_packages": 'Paket',
  "center_collection1_service": 'Servicetjänster',
  "center_collection1_transport": 'Servicetjänster',
  "center_collection1_title": 'PLANERA RESAN',
  "center_collection1_webcams": 'Webbkamera',
  "center_collection2_calendar": 'Eventkalender',
  "center_collection2_food": 'Äta och dricka',
  "center_collection2_gaustabanen": 'Gaustabanen',
  "center_collection2_gaustaoppen": 'Gaustatoppen',
  "center_collection2_see": 'Se och göra',
  "center_collection2_skisenter": 'Gausta skisenter',
  "center_collection2_title": 'UPPLEV GAUSTA',
  "center_collection2_travel": 'Reseguider',
  "center_collection3_courses": 'Upplevelser och kurser',
  "center_collection3_rental": 'Skiduthyrning',
  "center_collection3_school": 'Skidskola och privatlektioner',
  "center_collection3_ski": 'Lifkort',
  "center_collection3_season": 'Sæsonbillet',
  "center_collection3_title": 'KÖP/BOKA',
  "check_in": "Ankomst",
  "check_out": "Avresa",
  "child": "Barn",
  "children": "Barn",
  "childrens_age": "Barnens ålder",
  "closed": "Stängt",
  "coming_days_prognosis": "Prognos för kommande dagar",
  "contact_information": "Kontaktinformation",
  "customer_service_collection_contact": 'Kontakta oss',
  "customer_service_collection_faq": 'FAQ',
  "customer_service_collection_save": 'Tryggt och säkert',
  "customer_service_collection_terms": 'Bokningsvillkor',
  "customer_service": "Kundservice",
  "eat_and_drink": "Mat & Dryck",
  "email_placeholder": "Din e-postadress",
  "error_404": "Sidan hittades inte",
  "events_choose_dates": "Välj start/slutdatum",
  "events_upcoming_dates": "Kommande datum",
  "events": "Evenemang",
  "facebook_read_more": "Läs mer på Facebook",
  "filter": "Filter",
  "fnugg_all_posts": "Se alla inlägg",
  "fnugg_cross_country": "Längdskidor",
  "fnugg_menu_cloud": "Molnigt",
  "fnugg_menu_fog": "Dimma",
  "fnugg_menu_gausta_today": "Gausta idag",
  "fnugg_menu_header": "Väder och driftstatus",
  "fnugg_menu_puder_alert": "Puder varning!",
  "fnugg_menu_rain": "Regn",
  "fnugg_menu_snow": "Snö",
  "fnugg_menu_storm": "Storm",
  "fnugg_menu_sun": "Soligt",
  "fnugg_menu_wind": "Vind",
  "fnugg_operation_status": "Driftstatus",
  "fnugg_report_coming_days": "Prognos för kommande dagar",
  "fnugg_report_last_day": "Senaste dygn",
  "fnugg_report_last_week": "Senaste veckan",
  "fnugg_report_terreng": "Terräng",
  "fnugg_report_weather_today": "Vädret idag",
  "fnugg_snow_depth": "Snödjup",
  "fnugg_temp": "Temperatur",
  "footer_collection_about": "Om Gausta",
  "footer_collection_cabins_rent": "Hyra ut din stuga?",
  "footer_collection_cabins_sale": "Stugor till salu",
  "footer_collection_career": "Jobba på Gausta",
  "footer_collection_news": "Nyheter",
  "footer_email_subscribe": "Få erbjudanden, nyheter och tips i din inkorg",
  "footerText": "Gausta.com är den officiella bokningsplattformen för destination Gausta. Här hittar du det bästa urvalet av boende i Gausta-området, liftkort till Gausta Skisenter, och ett stort utbud av aktiviteter och exklusiva paket och erbjudanden.",
  "from_13_years": "Från 13 år",
  "from": "Från",
  "guests": "Gäster",
  "hotel": "Hotell",
  "last_day": "Sista dagen",
  "last_updated": "Senaste uppdatering",
  "last_week": "Förra veckan",
  "lifts": "Liftar",
  "mail": "E-post",
  "map_temp": "Temp",
  "map_wind": "Vind",
  "maps_cross": "Längdskidspår",
  "maps_summer": "Sommarkarta",
  "maps_winter": "Pistkarta",
  "menu": "Meny",
  "my_pages": "Mina sidor",
  "on_this_page": "På denna sida",
  "only_lights": "Kvällsöppna backar",
  "only_open": "Endast öppna",
  "open": "Öppet",
  "opened": "Öppnad",
  "other": "Övrigt",
  "overview": "Översikt",
  "packages": "Paket",
  "phone_number": "Telefonnummer",
  "policy": "Personuppgiftspolicy",
  "read_more": "Läs mer",
  "results": "Resultat",
  "search_and_book": "Sök och boka",
  "search_placeholder": "Sök på Gausta.com",
  "search": "Sök",
  "searchwidget_activities": "Aktiviteter",
  "searchwidget_adults_age": "Från 13 år",
  "searchwidget_adults": "Vuxna",
  "searchwidget_age": "Ålder",
  "searchwidget_arrival": "Ankomst",
  "searchwidget_cabins": "Stugor och lägenheter",
  "searchwidget_child": "Barn",
  "searchwidget_children_age": "Ålder 0-12",
  "searchwidget_children": "Barn",
  "searchwidget_departure": "Avresa",
  "searchwidget_guests": "GÄSTER",
  "searchwidget_hotel": "Hotell",
  "searchwidget_label_from": "Från",
  "searchwidget_label_to": "Till",
  "searchwidget_picker_title": "Barnens ålder",
  "searchwidget_skisenter_item": "Lifkort",
  "searchwidget_skisenter_item2": "Skidskola",
  "searchwidget_skisenter_item3": "Privatlektioner",
  "searchwidget_skisenter_item4": "Upplevelser och kurser",
  "searchwidget_skisenter_item5": "Skiduthyrning",
  "searchwidget_skisenter": "Gausta Skisenter",
  "searchwidgetmobile_title": "Boka",
  "skicenter": "Gausta Skisenter",
  "slopes": "Backar",
  "snow_depth": "Snödjup",
  "soMeText": "Håll dig uppdaterad",
  "subscribe": "Prenumerera",
  "terrain": "Terräng",
  "to_12_years": "Ålder 0-12",
  "to": "Till",
  "top_collection_accomodation": 'Boende',
  "top_collection_food": 'Äta och dricka',
  "top_collection_gaustabanen": 'Gaustabanen',
  "top_collection_packages": 'Paket',
  "top_collection_see": 'Se och göra',
  "top_collection_skisenter": 'Gausta skisenter',
  "topNotificationLink": "Renovering av hotellrum",
  "topNotificationMessage": "Under perioden 28 september till 18 december kommer Gaustablikk Fjellresort att renovera 60 rum.",
  "topRedBar_button": "Läs mer",
  "topRedBar_message": "Under perioden 28 september till 18 december kommer Gaustablikk Fjellresort att renovera 60 rum.",
  "upcoming": "Kommande",
  "view_only": "VISA ENDAST",
  "visit": "Besök",
  "weather_today": "Vädret idag",
  "weather": "Väder",
  "webcams": "Webbkameror",
  "website": "Hemsida",
  "widget_book_at_gausta": "Boka",
  "wind": "Vind",
  "newpassword": "Skapa ett nytt lösenord",
  "resetPassword": "Ditt nya lösenord är nu sparat!",
  "buttonContinueText": "Fortsätta",
  "newPasswordDescription": "Skapa nytt lösenord",
  "newPasswordDescription2": "För att skapa ett nytt lösenord, ange din e-postadress:",
  "temporaryPasswordDescription": "Ett nytt tillfälligt lösenord har nu skickats till dig på följande e-postadress:",
  "temporaryPasswordDescription2": "Om denna e-postadress är registrerad får du nu ett tillfälligt lösenord i din inkorg. Ange detta i fältet nedan:",
  "temporaryPasswordLabel": "Tillfälligt Lösenord",
  "belowPassword": "Nedan kan du ange ett valfritt lösenord:",
  "newPasswordLabel": "Nytt lösenord",
  "repeatPasswordLabel": "Repetera lösenord",
  "email": "E-post",
  "login": "Logga in",
  "password": "Lösenord",
  "forgotPassword": "Glömt ditt lösenord?",
  "accountNotFound": "Tyvärr, men den här e-postadressen verkar inte vara länkad till något användarkonto.",
  "wrongPassword": "Tyvärr, men lösenordet verkar inte vara korrekt",
  "unexpectedError": "Oväntat fel",
}

export default sv;
